import { useState } from 'react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Loader2, Lock, FileText } from 'lucide-react';

export const FollowUpTemplate = ({ thread, onFollowUp }) => {
  const [reference, setReference] = useState('');
  const [sending, setSending] = useState(false);
  const blocked = !thread.user
    ? 'Not linked to a ParachPay account, so a template can\'t be sent.'
    : !thread.user.whatsapp_opt_in
      ? 'This user has opted out of WhatsApp messages.'
      : null;

  const send = async () => {
    setSending(true);
    if (await onFollowUp(reference.trim())) setReference('');
    setSending(false);
  };

  return (
    <div className="space-y-2" data-testid="inbox-follow-up">
      <p className="flex items-center gap-2 text-xs text-muted-foreground" data-testid="inbox-window-closed-note">
        <Lock className="w-4 h-4 shrink-0" />
        The 24-hour window has closed. Free-text replies are disabled; you can send the approved follow-up template.
      </p>
      {blocked ? (
        <p className="text-xs text-red-500" data-testid="inbox-follow-up-blocked">{blocked}</p>
      ) : (
        <div className="flex gap-2">
          <Input
            value={reference}
            onChange={(e) => setReference(e.target.value)}
            maxLength={40}
            placeholder="Request reference, e.g. SUP-1042"
            className="h-10 rounded-xl"
            data-testid="inbox-follow-up-reference"
          />
          <Button onClick={send} disabled={sending || !reference.trim()} className="rounded-xl h-10 shrink-0" data-testid="inbox-follow-up-send-btn">
            {sending ? <Loader2 className="w-4 h-4 animate-spin" /> : <FileText className="w-4 h-4 mr-2" />}
            Send follow-up template
          </Button>
        </div>
      )}
    </div>
  );
};
